var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ActionButton',{attrs:{"click-action":_vm.approve,"title":_vm.item && _vm.item.approved ? _vm.$t('general.reject') : _vm.$t('general.approve'),"disabled":_vm.disabled}},[(_vm.item && _vm.item.approved)?_c('b-icon-x'):_c('b-icon-check')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }